import { render, staticRenderFns } from "./vendor-detail-page.vue?vue&type=template&id=3a5dcf9e&"
import script from "./vendor-detail-page.vue?vue&type=script&lang=js&"
export * from "./vendor-detail-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports